import React,{useState,useRef,useEffect} from 'react'
import axios from 'axios'
import Cleave from 'cleave.js/react'
import { Formik, Field, FieldArray } from 'formik'
import { Form, Input, TextArea, Button, Select, Step, Label, Dropdown, Dimmer, Loader, Icon, Message, Modal, Checkbox, Popup, Table, Segment } from 'semantic-ui-react'

import Spinner from '../../services/spinner'
import AlertMessage from '../../services/alert'
import { WindowReload, WindowURL, WindowLocation, RouteURL, RedirectURL, CurrencySymbol } from '../../services/redirect'
import { ValidateForm } from '../../validations/schemaProduct'
import { DropdownComponent } from '../../components/options'
import AuthDenied from '../ErrorPage/denied'


export default function NewProductComponent(props){


  /*----------------------------------------
    SPINNER
  -----------------------------------------*/
  const [submitSpinner, setsubmitSpinner] = useState(false);
  const [spinner,setspinner] = useState(true);
  const [contentspinner, setcontentspinner] = useState({});
  function SpinnerCallback(data){
    if(data.intent=='close'){
      setspinner(false);
    }
  }


  /*------------------------------------------------------
    ALERT MESSAGE NOTIFY
  -------------------------------------------------------*/
  const [notify,setnotify] = useState(true);
  const [nofitycontent, setnofitycontent] = useState({});
  function Notifycallback(data){
    if(data.intent=='close'){
      setnotify(false);
    }
  }



  /*----------------------------------------
    Handle Form Submit
  -----------------------------------------*/
  const buttonEl = useRef(null);
  const [buttonclick, setbuttonClick] = useState(0);
  function buttonSubmit(arg){
      setbuttonClick(arg);
      buttonEl.current.click();
  }
  const [state, setState] = useState({
    name:'',
    code:'',
    price:'0.00',
    status:'1',
    description:'',
    product_compliance:[],
    country_compliance:[]
  });

  function handleSubmitForm(values, props){

    setcontentspinner({intent:'spinner',settings:{options:'overlay',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Processing',text:""}});
    setsubmitSpinner(true);

    //console.log(values);
    //.log(values.product_compliance);
    //return false;

    let formData = new FormData();
    formData.append('type','add');
    formData.append('info',JSON.stringify(values));
    axios.post('/admin/products/request.php',formData)
    .then(function (response) {
      let obj = response.data;

      setsubmitSpinner(false);

      if(obj=='success'){
        setnofitycontent({intent:'success',settings:{onclose:true,reload:false,title:'Congratulations!',text:'Data successfully saved.'}});
        setnotify(true);
        setTimeout(function() {setnotify(false);},2000);
        if(buttonclick==1){
          setTimeout(function() {
            WindowLocation('/products/list');
          },2000);
        }else{
          setTimeout(function() {
            setnotify(false);
            WindowReload();
          },2000);
        }
        return false;
      }


      if(obj=='error'){
        setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Something Wrong!',text:'Failed to connect through the server.'}});
        setnotify(true);
        setTimeout(function() {
          setnotify(false);
        },3000);
        return false;
      }

      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Input Error!',text:'Please correct the required fields.'}});
      setnotify(true);
      setTimeout(function() {
        setnotify(false);
      },3000);

      Object.keys(obj).forEach(function(key) {
        props.setErrors(obj);
      });

      

    })
    .catch(function (error){
      setspinner(false);
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {
        setnotify(false);
      },3000);
    });
  }


  /*------------------------------------------------------
          DROPDOWN OPTIONS
  -------------------------------------------------------*/
  const [statusOptions, setStatusOptions] = useState([]);
  const HandleOptions = async () => {
    const source = await DropdownComponent();
    setStatusOptions(source.status);
  }



  /*------------------------------------------------------
          COMPLIANCE LIST
  -------------------------------------------------------*/
  function GetListCompliance(){

    setcontentspinner({intent:'spinner',settings:{options:'relative',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Loading',text:""}});
    setspinner(true);

		let formData = new FormData();
		formData.append('type','compliance');
		axios.post('/admin/products/request.php',formData)
		.then(function (response) {
				let obj = response.data;
        setState({
          ...state,
          product_compliance:obj.product_compliance,
          country_compliance:obj.country_compliance
        });

        console.log(obj.product_compliance);
				setspinner(false);
		})
		.catch(function (error){
      setspinner(true);
      setnofitycontent({intent:'error',settings:{onclose:false,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
		});
	}



  /*---------------------------------------------------------------------------------------------------------------------------------------
         AUTH PERMISSION FOR PAGES
  ----------------------------------------------------------------------------------------------------------------------------------------*/
  const [loader,setloader] = useState(true);
  const [pageId, setPageId] = useState('yt2d71v4r8p36qfwe');
  const [authPages, setAuthPages] = useState({
    view:0,
    adding:0,
    editing:0,
    deleting:0
  });
  function AuthPagesPermission(){

    setcontentspinner({intent:'spinner',settings:{options:'relative',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Loading',text:""}});
    setloader(true);

    let formData = new FormData();
    formData.append('type','authPages');
    formData.append('id',pageId);
    axios.post('/admin/users-management/users-permission/request.php',formData)
    .then(function (response) {
        let obj = response.data;
        setAuthPages({
          view:obj.view,
          adding:obj.adding,
          editing:obj.editing,
          deleting:obj.deleting,
        });

        if(obj.view==1){
          GetListCompliance();
        }
        setloader(false);
        setspinner(false);

    })
    .catch(function (error){
      setloader(false);
      setspinner(true);
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {setnotify(false);},3000);
    });
 }

  useEffect(()=>{
    AuthPagesPermission();
    HandleOptions();
  },[]);

  return (
    <React.Fragment>

      {spinner&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}
      {notify&&<AlertMessage data={nofitycontent} callback={Notifycallback}/>}
      {submitSpinner&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}

      {((authPages['view']==0||authPages['adding']==0)&&!spinner)&&<AuthDenied/>}
      {(authPages['view']==1&&!spinner)&&<React.Fragment>

      <div className="page-wrapper-half">
        <div className="app-page-title">
         <div className="page-title-wrapper">
            <div><h1>New Product</h1></div>
            <div>
              <Button className='LightGrayButton strong' size='tiny' content='Refresh' icon='sync alternate icon' onClick={()=>WindowReload()}/>
              <Button className='GreenButton strong' size='tiny' content='Back to list' icon='arrow left icon' as="a" href={WindowURL('/products/list')}/>
            </div>
          </div>
       </div>
      <div className="app-body-wrapper">
      <Form>
        <Formik
            enableReinitialize
            initialValues={state}
            validationSchema={ValidateForm}
            onSubmit={handleSubmitForm}
            >
            {({ values, isSubmitting, errors, handleChange, handleBlur, handleSubmit, isValid, dirty, touched, setFieldValue, setFieldTouched }) => {
            return(
                    <div className="page-form-panel">
                        <div className="page-form-body">

                        <div class="alert-message left error">
                            <div><i class="info circle icon"></i></div>
                            <div><p>Fields with asterisk is required.</p></div>
                        </div>
                        <br/>

                         <Form.Group widths="equal">
                            <Field name="name">
                                {({ field, form }) => (
                                <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                  <label>Name</label>
                                  <Input {...field} onChange={handleChange}/>
                                  { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                </Form.Field>
                                )}
                          </Field>
                        </Form.Group>
                        <Form.Group widths="equal">
                          <Field name="code">
                                {({ field, form }) => (
                                <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                  <label>Code</label>
                                  <Input {...field} onChange={handleChange}/>
                                  { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                </Form.Field>
                                )}
                          </Field>
                         </Form.Group>

                         <Form.Group widths="equal">
                            <Field name="price">
                                {({ field, form }) => (
                                <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                  <label>Selling Price</label>
                                  <Cleave {...field}
                                        onChange={event => {
                                          setFieldValue('price',event.target.rawValue);
                                      }} options={{numeral: true, numeralThousandsGroupStyle: 'thousand', prefix:CurrencySymbol()+' ', rawValueTrimPrefix: true}}/>
                                  { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                </Form.Field>
                                )}
                            </Field>
                         </Form.Group>

                         <Form.Group widths="equal">
                           <Field name="status">
                             {({ field, form }) => (
                                 <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                   <label>Status</label>
                                   <Select
                                       selectOnBlur={false}
                                       {...field}
                                       options={statusOptions}
                                       onChange={(e, { value }) => setFieldValue(field.name,value)}/>
                                   { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                 </Form.Field>
                             )}
                           </Field>
                         </Form.Group>

                         <Form.Group widths="equal">
                            <Field name="description">
                                {({ field, form }) => (
                                <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                  <label>Description</label>
                                  <TextArea {...field} onChange={handleChange}/>
                                  { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                </Form.Field>
                                )}
                            </Field>
                         </Form.Group>
                         
                         {/*className='checkdisabled' defaultChecked={data.is_check==1?'true':''} disabled={data.is_check==1?true:false}*/}

                         {values.product_compliance.length>0&&<div className="compliance-wrapper">
                           <div class="ui attached tabular menu">
                             <a class="active item">Additional Compliance Statement</a>
                           </div>
                           <div class="ui bottom attached segment active tab">
                             <FieldArray
                               name="product_compliance"
                               render={arrayHelpers => (
                                  <div>
                                     {values.product_compliance.map(function(data, key){
                                       return<Form.Group inline>
                                         <Form.Checkbox 
                                           name="product_compliance" 
                                           id={'product_compliance'+key} 
                                           defaultChecked={data.is_check==1?'true':''}
                                           label={data.message}
                                           onChange={e => {
                                             if(e.target.checked){
                                               setFieldValue(`product_compliance[${key}].is_check`,1);
                                             }else{
                                               setFieldValue(`product_compliance[${key}].is_check`,0);
                                             }
                                           }}
                                         />
                                      </Form.Group>
                                 	 })}
                                   </div>
                                 )}/>
                           </div>
                        </div>}


                        {values.country_compliance.length>0&&<div className="compliance-wrapper">
                          <div class="ui attached tabular menu">
                            <a class="active item">Country Compliance Statement</a>
                          </div>
                          <div class="ui bottom attached segment active tab">
                            <FieldArray
                              name="country_compliance"
                              render={arrayHelpers => (
                                 <div>
                                    {values.country_compliance.map(function(data, key){
                                      return<Form.Group inline>
                                        <Form.Checkbox name="country_compliance"  
                                          id={'country_compliance'+key} 
                                          defaultChecked={data.is_check==1?'true':''}
                                          label={data.message}
                                          onChange={e => {
                                            if(e.target.checked){
                                              setFieldValue(`country_compliance[${key}].is_check`,1);
                                            }else{
                                              setFieldValue(`country_compliance[${key}].is_check`,0);
                                            }
                                          }}
                                        />
                                     </Form.Group>
                                  })}
                                  </div>
                                )}/>
                          </div>
                       </div>}



                        </div>{/*.page-form-body*/}

                        <div className="page-form-footer">
                            <Button disabled={spinner||authPages['adding']==0} className='LightGrayButton strong' size='small' content='Save and back to list' icon='save icon' onClick={() => buttonSubmit(1)}/>
                            <Button disabled={spinner||authPages['adding']==0} className='PrimaryButton strong' size='small' content='Save and stay on page' icon='save icon' onClick={() => buttonSubmit(2)}/>
                            <button type="button" className="display_none" ref={buttonEl} onClick={handleSubmit}></button>
                        </div>

                 </div>

             )}}
            </Formik>
          </Form>
          </div>
        </div>
      </React.Fragment>}
    </React.Fragment>
  )
}
